import { NfseStatus } from "./nfse-status.enum";

export interface NfseActionResponse {
  id: string;
  idInspection: string;
  status: number;
  protocolo?: string | null;
  mensagem: string;
}

/** Catálogo Id ↔ nome (tabela NfseInvoiceStatus). */
export const NFSE_STATUS_ID: Record<number, NfseStatus> = {
  1: "NaoIniciada",
  2: "EmPreparacao",
  3: "EmissaoSolicitada",
  4: "Autorizada",
  5: "Rejeitada",
  6: "FalhaIntegracao",
  7: "PendenteCorrecao",
  8: "EmReprocessamento",
  9: "CancelamentoSolicitado",
  10: "Cancelada",
  11: "EnviadaPorEmail",
  12: "FalhaEnvioEmail",
  13: "Reenviada",
};

export function nfseStatusFromId(id: number): NfseStatus | null {
  return NFSE_STATUS_ID[id] ?? null;
}
